module.exports = __webpack_public_path__ + "img/gong-zhong-hao.d35fb9d1.jpg";